// extracted by mini-css-extract-plugin
export default {"authPage":"AuthenticationPage_authPage__3mOa6","authContainer":"AuthenticationPage_authContainer__50jYO","authSection":"AuthenticationPage_authSection__XA07w"};